module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.825 12.38a.5.5 0 0 1-.65 0C4.003 12.232 0 8.752 0 5.02 0 2.53 2.018.5 4.5.5 6.981.5 9 2.529 9 5.021c0 3.731-4.004 7.212-4.175 7.359zM4.5 1.5C2.57 1.5 1 3.08 1 5.021c0 2.702 2.574 5.412 3.5 6.299.925-.888 3.5-3.603 3.5-6.299C8 3.08 6.43 1.5 4.5 1.5zm0 5.537c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3c-.551 0-1 .449-1 1a1.001 1.001 0 1 0 1-1z\" fill=\"#49626D\" fill-rule=\"nonzero\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-inline-loader?removeTags=true!./src/images/svg/location-pin.svg
// module id = 8BMD
// module chunks = 89